import React from 'react';
import PropTypes from 'prop-types';
import FeaturedImage from '../FeaturedImage';
import useSettingsContext from '../../context/useSettingsContext';
import useCore from '../../methods/core/useCore';
import useUtilities from '../../methods/utilities/useUtilities';

function WebinarPost(props) {
  const {
    postType,
    displayAuthor,
    displayExcerpt,
    displayDate,
    displayCategories
  } = useSettingsContext();

  const {post} = props;
  const {replaceSelected} = useCore();
  const {theExcerpt} = useUtilities();
  let categories;
  let categoryItems;
  let featuredImage;
  let author;
  let excerpt;
  let date;

  WebinarPost.propTypes = {
    post: PropTypes.object
  }

  if (post.featured_image !== undefined && post.featured_image !== '' && post.featured_image !== false) {
    featuredImage = <a href={post.link} className="eight29-featured-image">
      <figure>
        <img src={post.featured_image}></img>
      </figure>
    </a>
  } else {
    featuredImage = <a href={post.link} className="eight29-featured-image">
      <figure>
        <img src={post.placeholder_image}></img>
      </figure>
    </a>
  }

  if (post.webinars_taxonomy !== undefined && post.webinars_taxonomy.length > 0) {
    categories = post.webinars_taxonomy;
  }

  if (categories) {
    categoryItems = categories.map((category) => {
      return (
        <a 
          key={category.term_id}
          href={`/webinars/category/${category.slug}`}
					className={`eight29-taxonomy-${category.taxonomy}`}
          dangerouslySetInnerHTML={{ __html:category.name}}></a>
      );
    });
  }

  return (
    <article id={`${postType}-${post.id}`} className="eight29-post eight29-post-card">
      {featuredImage}

      <div className="eight29-post-body">
        <div className="eight29-post-head">
          <div className="eight29-post-categories">
            {categoryItems}
          </div>
        </div>

        <h4 className="eight29-post-title"><a href={post.link} dangerouslySetInnerHTML={{__html: post.title.rendered}}></a></h4>

        <div className="eight29-post-detail">
          <a href={post.link} className="eight29-post-link" >
            <i className="icon icon-arrow-right"></i>
          </a>
        </div>
      </div>
    </article>
  );
}

export default WebinarPost; 